import styled from "styled-components";
import { CenterView, Icon } from "../../../Component/style/common_style";
const Notify_banner = styled(CenterView)`
  background-color: #3a3939;
  width: 100%;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &.none {
    height: 0;
  }
`;
const Notify = (props: { img: string; url: string }) => {
  const img = props.img;
  const url = props.url;

  const go_url = () => {
    if (url) window.open(url);
  };

  return (
    <Notify_banner className={img ? "" : "none"} onClick={go_url}>
      {/* {img && <Icon src={img} />} */}
      {img && <Icon src={require("../../../Image/image_test.png")} />}
    </Notify_banner>
  );
};

export default Notify;
